/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, Flex, FormControl, FormLabel, IconButton, Text, Tooltip } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { Field, FieldArray, ErrorMessage } from 'formik';
import { MinusIcon } from '@chakra-ui/icons';
import DownloadAndViewButton from '../Files/DownloadAndViewButton';
import TempFileUploader from '../Files/TempFileUploader';
import c from '../../constant';

const MultipleFileFormField = ({ name = null, label = null, required = false, editing = false }) => {
	const { t } = useTranslation();

	return (
		<FieldArray name={name}>
			{({ remove, push, form }) => {
				return (
					<Box width="100%" borderColor={'black'}>
						<FormLabel>
							{t(label)}
							{required && <span>*</span>}
						</FormLabel>
						{form?.values[name]?.map((value, i) => {
							return (
								<Flex key={i} mb={i === form?.values[name]?.length - 1 ? 0 : 1}>
									<Flex flex={1}>
										<Field name={name + '.' + i}>
											{({ meta, form }) => {
												return (
													<FormControl>
														<Box width="100%">
															{value?.file ? (
																<Flex width="100%">
																	<Box width="100%">
																		<DownloadAndViewButton url={value?.file} size={value?.size} marginLeft={0} />
																	</Box>
																	{editing && (
																		<Flex justifyContent="flex-end" alignItems="center">
																			<Tooltip label={t('Remove')}>
																				<IconButton
																					size="xs"
																					isRound={true}
																					variant="solid"
																					colorScheme="red"
																					icon={<MinusIcon />}
																					borderRadius={30}
																					ml={2}
																					onClick={() => remove(i)}
																				/>
																			</Tooltip>
																		</Flex>
																	)}
																</Flex>
															) : (
																<Flex width="100%">
																	<Box width="100%">
																		<TempFileUploader
																			callBack={(uploadedFile) => {
																				const updatedFiles = [...form.values[name]];
																				updatedFiles[i] = {
																					file: '',
																					size: 0,
																					tempFile: uploadedFile?.id,
																				};
																				form.setFieldValue(name, updatedFiles);
																			}}
																			callBackUploading={(uploading) => {}}
																			label={null}
																			required={true}
																			onCancelFile={() => remove(i)}
																			disabled={false}
																			mt={0}
																			mb={0}
																			size="sm"
																			type="companyCertificateType"
																		/>
																	</Box>
																	<Flex justifyContent="flex-end" alignItems="center">
																		<Tooltip label={t('Remove')}>
																			<IconButton
																				size="xs"
																				isRound={true}
																				variant="solid"
																				colorScheme="red"
																				icon={<MinusIcon />}
																				borderRadius={30}
																				ml={2}
																				onClick={() => remove(i)}
																			/>
																		</Tooltip>
																	</Flex>
																</Flex>
															)}
															{meta.touched && meta.error && (
																<ErrorMessage
																	name={`${name}.${i}.tempFile`}
																	children={(errorMessage) => (
																		<Text textAlign="left" mt={1} color="red">
																			{t('File')} {t('is')} {t(errorMessage)}
																		</Text>
																	)}
																/>
															)}
														</Box>
													</FormControl>
												);
											}}
										</Field>
									</Flex>
								</Flex>
							);
						})}
						<Flex justifyContent="flex-start" alignItems="center" mt={form?.values[name]?.length > 0 ? 4 : 0}>
							<Tooltip label={t('Add')}>
								<Button
									size="md"
									colorScheme="blue"
									variant="solid"
									borderRadius={c.borderRadius}
									pl={6}
									pr={6}
									ml={0}
									mb={4}
									onClick={() => push({ url: '', size: 0, tempFile: '' })}
								>
									{t('Add File')}
								</Button>
							</Tooltip>
						</Flex>
					</Box>
				);
			}}
		</FieldArray>
	);
};

export default MultipleFileFormField;
